export default "__VITE_ASSET__1a749706__"